<template>
  <div class="loading-overlay">
    <div class="spinner-container">
      <i class="fa fa-spinner fa-spin" />
      <div class="loading-text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    text: {
      type: String,
      default: 'Loading...'
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
  .spinner-container {
    text-align: center;
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    
    i.fa-spinner {
      font-size: 2rem;
      color: $col-button;
    }
    
    .loading-text {
      margin-top: 0.5rem;
      font-size: 0.9rem;
    }
  }
}
</style>
